<template>
  <section class="section">
    <div class="container">
      <section class="section">
          <check-success></check-success>
        <div class="space10 has-text-centered">
          <p>Deine Kaffee wurde auf der Liste gespeichert!</p>
        </div>
      </section>
      <section class="section">
          <div class="has-text-centered">
              <p>Redirect in {{count}} sek. oder direkt auf <router-link to="/">zurück</router-link></p>
              <!--
              <progress class="progress is-small" :value="redirectWaitSec - count" :max="redirectWaitSec">0%</progress>
              -->

          </div>
      </section>
    </div>
  </section>
</template>

<script>
import CheckSuccess from '../components/CheckSuccess'

export default {
    name: 'orderStepSuccess',
    components: {
        CheckSuccess
    },
    data() {
        return {
            redirectWaitSec: 3,
            interval: "",
            count: 0,
        }
    },
    methods: {
        timerEnded: function() {
            console.log("Redirecting...");
            this.$router.push('/');
        },
        timerCountdown: function() {
            const distance = this.count - 1;
            if (distance <= 0) {
                clearInterval(this.interval);
                this.timerEnded();
            }
            this.count = distance;
        }
    },
    mounted() {
        this.count = this.redirectWaitSec;
        this.interval = setInterval(() => {
            this.timerCountdown()
        }, 1000);

        // create a timer for 5 seconds
    },
    beforeDestroy() {
        clearInterval(this.interval);
    }
}
</script>

<style scoped>
.space10 {
    margin-top: 1rem;
}
</style>



